/* eslint-disable @typescript-eslint/no-empty-function */
import React, { createContext, useState, useContext, ReactNode } from 'react';

interface SizeProps {
  isMobile?: boolean;
  setIsMobile: (value: boolean) => void;
}

const SizeContext = createContext<SizeProps>({
  setIsMobile: () => {},
  isMobile: false,
});

export const useSizeContext = () => useContext(SizeContext);

interface Props {
  children: ReactNode;
}
export const SizeProvider = ({ children }: Props) => {
  const [isMobile, setIsMobile] = useState(false);

  return <SizeContext.Provider value={{ isMobile, setIsMobile }}>{children}</SizeContext.Provider>;
};

export default SizeContext;
